import { providerType } from '@repo/shared/types';
export var isLiberisPromoted = function (merchantResponse) {
    var _a;
    return Boolean((_a = merchantResponse.config.find(function (config) { return config.provider === providerType.enum.liberis; })) === null || _a === void 0 ? void 0 : _a.default);
};
